/**
 * Tiny classnames merger used throughout the UI.
 *
 * `clsx` handles conditional class logic; `tailwind-merge` ensures that
 * conflicting Tailwind classes (e.g. passing `p-2` on a component whose
 * default is `p-4`) resolve the way you'd intuitively expect.
 */
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
